import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const lightningsTutorial = (id, buttonText) => [
  {
    element: '.lightnings_shortcut',
    intro: 'Tu dodasz skrót do pulpitu.'
  },
  {
    element: '.lightnings_interpolation',
    intro: 'Tu ustawisz interpolacje kolorów dla lokalizacji wyładowań (punkty na mapie)'
  },
  {
    element: '.lightnings_pointSize',
    intro:
      'Możesz również ustawić wielkość punktu wyładowania atmosferycznego. Uważaj na wydajność! Im większy punkt tym więcej pamięci RAM zostanie wykorzystane. Punktów mogą być tysiące.'
  },
  {
    element: '.lightnings_alpha',
    intro: `Tu ustawisz przezroczystość punktu wyładowania. Niezalecane (może powodować problemy z czytelnością mapy). ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
